import React, { useContext, useEffect, useState } from "react";
import { CircularProgress, makeStyles, Button, Typography } from "@material-ui/core";
import CustomDatePicker from "../../../components/UI/CustomDatePicker";
import DialogAcerBrag from "../../../components/UI/DialogAcerBrag";
import LimitedBackdrop from "../../../components/UI/LimitedBackdrop";
import { AppContext } from "../../../contexts/AppContext";
import { separations } from "../../../constants/StyleConstants";
import { Fragment } from "react";

import SupplierFilter from "../../../components/SupplierFilter/SupplierFilter";
import SupplierExclusionCertificatesAPI from "../../../services/SupplierExclusionCertificatesAPI";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  ...separations,
  dialogContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: "30em",
  },
  contiguous: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridGap: "1em",
  },
}));

const CertificateExclusionSupplierDialog = ({ open, setOpen, reloadGrid }) => {
  const classes = useStyles();
  const { showError, showWarning, showSuccess, showInfo } = useContext(AppContext);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [excludedSupplier, setExcludedSupplier] = useState(false);
  const [startDateExclusion, setStartDateExclusion] = useState(null);
  const [endDateExclusion, setEndDateExclusion] = useState(null);
  const [readOnly, setReadOnly] = useState(false);

  const [firstLoad, setFirstLoad] = useState(true);
  const [supplierId, setSupplierId] = useState(null);
  const [modification, setModification] = useState(false);
  const [endDateExclusionPrev, setEndDateExclusionPrev] = useState(null);

  const resetFields = () => {
    setSelectedSupplier(null);
    setEndDateExclusion(null);
    setStartDateExclusion(null);

    setModification(false);
  };

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        resetFields();
      }, 200);
    }
  }, [open]);

  const handleSave = () => {
    setOpenBackDrop(true);

    const startDateFormatted = startDateExclusion.toISOString().split("T")[0];
    const endDateFormatted = endDateExclusion.toISOString().split("T")[0];

    const request = {
      SupplierCuit: selectedSupplier.cuit,
      SupplierName: selectedSupplier.businessName,
      StartDate: startDateFormatted,
      EndDate: endDateFormatted,
    };

    SupplierExclusionCertificatesAPI.insertExcludedCertificate(request)
      .then((res) => {
        showSuccess("El proveedor se ha excluido exitosamente");
        setExcludedSupplier(true);
        setReadOnly(true);
      })
      .catch((error) => {
        setOpen(false);
        showError("Error al excluir al proveedor");
      })
      .finally(() => {
        setOpenBackDrop(false);
        setOpen(false);
      });
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !selectedSupplier)) {
      errorMessages.push("Debe ingresar el proveedor");
    }

    if ((errors[i++] = !startDateExclusion)) {
      errorMessages.push("Debe completar el campo de la Fecha desde");
    }

    if ((errors[i++] = !endDateExclusion)) {
      errorMessages.push("Debe completar el campo de la Fecha hasta");
    } else {
      if (
        (errors[i++] = moment(startDateExclusion) > moment(endDateExclusion))
      ) {
        errorMessages.push(
          "Debe ingresar una Fecha hasta mayor a la Fecha desde"
        );
      }
    }

    const hasErrors = errors.some((e) => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSave = () => validate() && handleSave();

  useEffect(() => {
    if (selectedSupplier) {
      handleSearchSupplier();

      setModification(false);
    } else {
      setReadOnly(false);
      setStartDateExclusion(null);
      setEndDateExclusion(null);
      setExcludedSupplier(false);
      setModification(false);
    }
  }, [selectedSupplier]);

  const handleSearchSupplier = (reload) => {
    const { cuit } = selectedSupplier;

    firstLoad && setFirstLoad(false);

    SupplierExclusionCertificatesAPI.getExcludedCertificate({
      SupplierCuit: cuit,
    })
      .then((res) => {
        if (res.length > 0) {
          setStartDateExclusion(res[0].startDate);
          setEndDateExclusion(res[0].endDate);
          setExcludedSupplier(true);
          setReadOnly(true);
          setSupplierId(res[0].id);

          setModification(true);
          setEndDateExclusionPrev(res[0].endDate);

          if (!reload) showInfo("El proveedor ya se encuentra excluido");
        } else {
          setReadOnly(false);
          setStartDateExclusion(moment());
          setEndDateExclusion(null);
          setExcludedSupplier(false);
          setEndDateExclusionPrev(null);
        }
      })
      .catch((error) => {
        setOpen(false);
        showError("Error al obtener el proveedor");
      });
  };

  const removeExclusion = () => {
    SupplierExclusionCertificatesAPI.removeExcludedCertificate({
      Id: supplierId,
    })
      .then((res) => {
        showSuccess("Se ha removido la exclusión al proveedor exitosamente");
        
      })
      .catch((error) => {
        showError("Error al remover la exclusión del proveedor");
      })
      .finally(() => {
        setModification(false);
        setOpen(false);
        resetFields();
        
      });
  };

  const modifyDate = () => {
    SupplierExclusionCertificatesAPI.setEndDate({
      Id: supplierId,
      EndDate: endDateExclusion,
    })
      .then((res) => {
        setExcludedSupplier(true);
        setReadOnly(true);
        setModification(false);
        showSuccess("Se ha modificado la exclusión exitosamente");
      })
      .catch((error) => {
        setOpen(false);
        showError("Error al modifcar la exclusión del proveedor");
      })
      .finally(() => {
        setOpenBackDrop(false);
        setOpen(false);
      });
  };

  const validateDateModify = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !endDateExclusion)) {
      errorMessages.push("Debe completar el campo de la Fecha hasta");
    } else {
      if (
        (errors[i++] = moment(startDateExclusion) >= moment(endDateExclusion))
      ) {
        errorMessages.push(
          "Debe ingresar una Fecha hasta mayor a la Fecha desde"
        );
      }
    }

    if (
      (errors[i++] =
        endDateExclusion === endDateExclusionPrev ||
        endDateExclusion.isSame(moment(endDateExclusionPrev)))
    ) {
      errorMessages.push(
        "Debe ingresar una nueva fecha en el campo Fecha hasta "
      );
    }

    const hasErrors = errors.some((e) => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndModify = () => validateDateModify() && modifyDate();

  return (
    <Fragment>
      <DialogAcerBrag
        open={open}
        setOpen={setOpen}
        title={"Excluir proveedor del requerimiento de certificado"}
        actionText={!readOnly && !modification && ""}
        action={!readOnly && !modification && undefined}
      >
        <LimitedBackdrop open={openBackDrop}>
          <CircularProgress color="primary" />
        </LimitedBackdrop>
        <div className={classes.dialogContainer}>
          <Fragment>
            <SupplierFilter
              value={selectedSupplier}
              setValue={setSelectedSupplier}
            />

            <div>
              <div
                className={classes.separationBetween}
                style={{ marginTop: "10px" }}
              >
                <CustomDatePicker
                  label={"Fecha desde"}
                  value={startDateExclusion}
                  setValue={setStartDateExclusion}
                  readOnly={excludedSupplier || readOnly}
                />
                <CustomDatePicker
                  label={"Fecha hasta"}
                  value={endDateExclusion}
                  setValue={setEndDateExclusion}
                  readOnly={(excludedSupplier || readOnly) && !modification}
                />
              </div>
              {!modification && !readOnly && (
                <div className={classes.filtersActionButton}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={validateAndSave}
                    style={{ margin: "45px 0 0 5px" }}
                  >
                    Excluir
                  </Button>
                </div>
              )}
              {excludedSupplier && (
                <div
                  className={classes.filtersActionButton}
                  style={{ marginTop: "10px" }}
                >
                  <Typography variant="contained" color="primary">
                    * El proveedor está excluido *
                  </Typography>
                  <div className={classes.filtersActionButton}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={removeExclusion}
                      style={{ margin: "15px 0 0 5px" }}
                    >
                      Remover
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={validateAndModify}
                      style={{ margin: "15px 0 0 10px" }}
                    >
                      Modificar
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Fragment>
        </div>
      </DialogAcerBrag>
    </Fragment>
  );
};
export default CertificateExclusionSupplierDialog;
